export const THEME_PRESETS = [
    {
        id: "gatiq",
        label: "GatiQ",
        swatch: "#C54E1B",
        // Empty = clear all overrides and inherit the platform default.
        values: {},
    },
    {
        id: "ocean",
        label: "Ocean",
        swatch: "#1E5AA8",
        values: {
            color1: "#1E5AA8",
            color2: "#F7F9FC",
            colorTextMuted: "#4A5568",
            radiusSm: "8px",
            radiusMd: "12px",
            radiusLg: "20px",
        },
    },
    {
        id: "forest",
        label: "Forest",
        swatch: "#2E7D32",
        values: {
            color1: "#2E7D32",
            color2: "#F8FAF8",
            colorTextMuted: "#4F5B52",
            radiusSm: "4px",
            radiusMd: "6px",
            radiusLg: "10px",
        },
    },
    {
        id: "slate",
        label: "Slate",
        swatch: "#334155",
        values: {
            color1: "#334155",
            color2: "#F8FAFC",
            colorTextMuted: "#64748B",
            sidebarStyle: "dark",
            radiusSm: "4px",
            radiusMd: "8px",
            radiusLg: "12px",
        },
    },
];
export const PRESET_MAP = Object.fromEntries(THEME_PRESETS.map((p) => [p.id, p]));
//# sourceMappingURL=presets.js.map